import * as React from 'react';
import ReactDOM from 'react-dom';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import {MobileDatePicker} from '@mui/x-date-pickers/MobileDatePicker';
import {AdapterMoment} from '@mui/x-date-pickers/AdapterMoment';
import {LocalizationProvider} from "@mui/x-date-pickers";
import moment from "moment";
import {useEffect, useState} from "react";
import bg from 'moment/locale/bg'
import {evropa, hitMladost, lulin, mladost} from "./DepartamentsInfo";
import Button from "@mui/material/Button";
import TiresDialog from "./TiresDialog";
import {useSearchParams} from "react-router-dom";
import {QuantitySelect} from "./QuantitySelect";
import {Alert, Chip, CircularProgress, InputAdornment, Tooltip} from "@mui/material";
import {EVROPA_PROMO} from "./MainForm";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardActionArea from "@mui/material/CardActionArea";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import MapIcon from "@mui/icons-material/Map";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";

const SERVICE_TYPE_DATA = [
    {id: 7, name: "ГТП", emoji: "📋", description: "Годишен технически преглед", bgColor: "#bf360c", image: "/service_types/gtp.png"},
    {id: 4, name: "Реглаж", emoji: "⚙️", description: "Геометрия на колелата", bgColor: "#1b5e20", image: "/service_types/reglaj.png"},
    {id: 1, name: "Гуми", emoji: "🛞", description: "Смяна и баланс на гуми", bgColor: "#0d47a1", image: "/service_types/gumi.png"},
];

// Add real photo URLs here when available — null falls back to the colored placeholder
const WORKSHOP_DATA = [
    {
        id: 1,
        name: "Люлин",
        description: "паркинг на HIT и Praktiker",
        image: "/services/lulin.png",
        reglajImage: "/services/reglaj/lulin.png",
        gumiImage: "/services/gumi/lulin.png",
        gtpImage: "/services/gtp/lulin.png",
        gtpImageStyle: {objectPosition: 'center center'},
        mapImage: "/service_maps/lulin_map.png",
        bgColor: "#1a237e",
        emoji: "🏭",
        mapUrl: "https://maps.app.goo.gl/66aEx7QNxpp1jpXR9",
        is_new: false,
    },
    {
        id: 5,
        name: "бул. Европа 144 В",
        description: "срещу Mr.Bricolage",
        image: "/services/evropa.png",
        reglajImage: "/services/reglaj/evropa.png",
        gtpImage: "/services/gtp/europa.png",
        gtpImageStyle: {objectPosition: 'left top'},
        mapImage: "/service_maps/evropa_map.png",
        bgColor: "#4a148c",
        emoji: "⚡",
        mapUrl: "https://maps.app.goo.gl/V6i19aqWjizPnjmQ7",
        is_new: false,
    },
    {
        id: 2,
        name: "Младост",
        description: "до Shell и McDonalds",
        image: "/services/mladost.png",
        gumiImage: "/services/gumi/mladost.png",
        gumiImageStyle: {transform: 'scaleX(1.026)', transformOrigin: 'left center'},
        mapImage: "/service_maps/mladost_shell_map.png",
        bgColor: "#004d40",
        emoji: "🔧",
        mapUrl: "https://maps.app.goo.gl/PFv5YhDVUJSHaAok7",
        is_new: false,
    },
    {
        id: 6,
        name: "Младост 3",
        description: "паркинг на HIT Max",
        image: "/services/mladost_hit.png",
        gtpImage: "/services/gtp/hit_mladost.jpg",
        mapImage: "/service_maps/mladost_shell_map.png",
        bgColor: "#006064",
        emoji: "🔩",
        mapUrl: 'https://maps.app.goo.gl/V9oY2FZ8PcMSA4vC7',
        is_new: true,
    },
];

const SERVICE_TYPE_IMAGE_KEY = {1: 'gumiImage', 4: 'reglajImage', 7: 'gtpImage'};
const SERVICE_TYPE_IMAGE_STYLE_KEY = {1: 'gumiImageStyle', 4: 'reglajImageStyle', 7: 'gtpImageStyle'};

const getWorkshopsForServiceType = (serviceTypeId, isExternalProductApplied, isEvropaPromo, promoServiceIds) => {
    let ids;
    if (isExternalProductApplied) {
        ids = [1, 2];
    } else if (isEvropaPromo) {
        ids = [5];
    } else if (promoServiceIds && promoServiceIds.length) {
        // Промо кодът важи само в определени обекти
        ids = promoServiceIds;
    } else {
        switch (serviceTypeId) {
            case 1: ids = [1, 2]; break;
            case 4: ids = [1, 5, 6]; break;
            case 7: ids = [1, 5, 6]; break;
            default: ids = [];
        }
    }
    return WORKSHOP_DATA.filter(w => ids.includes(w.id));
};

export default function PaymentForm(props) {
    moment.locale("bg");
    const [searchParams] = useSearchParams();

    // After 19:30 there are no more slots today — jump to tomorrow by default.
    // Hotel rule (today+2) takes priority and is enforced via useEffect below.
    const isPastCutoff = moment().isAfter(moment().set({hour: 19, minute: 30, second: 0, millisecond: 0}));

    const getDefaultDate = () => {
        if (props.externalProductName && props.externalProductQuantity) return moment().add(2, 'days').startOf('day');
        if (isPastCutoff) return moment().add(1, 'days').startOf('day');
        return moment();
    };

    // Step 1 date — restored to previously selected date when navigating back from step 2
    const [selectedDate, setSelectedDate] = useState(props.date || getDefaultDate());
    const [slotsByWorkshop, setSlotsByWorkshop] = useState({}); // key: workshopId
    const [loadingSlots, setLoadingSlots] = useState(false);

    // Pending slot selection — clicking a chip marks it; sticky button confirms and advances
    const [selectedSlot, setSelectedSlot] = useState(
        props.service && props.hourSelected
            ? {workshopId: props.service, hour: props.hourSelected}
            : null
    );

    // Which workshops have had "Покажи повече" clicked
    const [expandedWorkshops, setExpandedWorkshops] = useState({});

    // Edit mode state
    const [isDateFocused, setDateFocused] = useState(false);
    const [isHourFocused, setHourFocused] = useState(false);
    const [availableHours, setAvailableHours] = useState([]);
    const [tiresDialogOpen, setTiresDialogOpen] = useState(false);
    const [datePickerOpen, setDatePickerOpen] = useState(false);

    // One-time pulse animation on the date field, so users realize it's clickable
    const [showTapHint, setShowTapHint] = useState(false);
    const tapHintShownRef = React.useRef(false);

    const isExternalProductApplied = props.externalProductName && props.externalProductQuantity;
    const isExternalImageProduct = isExternalProductApplied && props.externalProductImage;
    const isEvropaPromo = props.externalPromoCode === EVROPA_PROMO;
    // Ограничения от разрешения промо код (GET /api/promo-code)
    const promoServiceType = props.promo?.serviceType || null;
    const promoServiceIds = props.promo?.serviceIds || null;

    // Auto-select Гуми service type for external products
    useEffect(() => {
        if (isExternalProductApplied) {
            props.setServiceType(1);
        }
    }, [isExternalProductApplied]);

    // Promo code fixed to one service type — preselect it and skip the service type step
    useEffect(() => {
        if (promoServiceType && !props.editMode) {
            props.setServiceType(promoServiceType);
            if (props.activeStep === 0) props.handleNext();
        }
    }, [promoServiceType]);

    // Fetch slots when entering step 1 (serviceType set) or when date changes
    useEffect(() => {
        if (!props.editMode && props.serviceType && props.activeStep === 1) {
            fetchSlotsForWorkshops(selectedDate, props.serviceType);
        }
    }, [selectedDate, props.serviceType, props.activeStep]);

    // When hotel status is known (auto-detected or manually chosen), or external tires applied, enforce the 2-day minimum
    useEffect(() => {
        if (props.isHotel || props.hotelPersonalChoice === "1" || isExternalProductApplied) {
            const minAllowed = moment().add(2, 'days').startOf('day');
            if (selectedDate.isBefore(minAllowed)) {
                setSelectedDate(minAllowed);
                setSlotsByWorkshop({});
            }
        }
    }, [props.isHotel, props.hotelPersonalChoice, isExternalProductApplied]);

    // Pulse the date field once, slightly delayed, when it first becomes visible.
    // Skipped when the user already picked a date (came back from step 2).
    const dateFieldVisible = !props.editMode && props.activeStep === 1 &&
        (props.serviceType !== 1 || isExternalProductApplied || props.hotelPersonalChoice != null);

    useEffect(() => {
        if (dateFieldVisible && !tapHintShownRef.current && !props.date) {
            const timer = setTimeout(() => {
                tapHintShownRef.current = true;
                setShowTapHint(true);
            }, 800);
            return () => clearTimeout(timer);
        }
    }, [dateFieldVisible]);

    // User found the picker on their own — hint no longer needed
    useEffect(() => {
        if (datePickerOpen) setShowTapHint(false);
    }, [datePickerOpen]);

    // Edit mode: reload hours when date changes
    useEffect(() => {
        if (props.editMode && props.date) {
            fetchHoursForEdit(props.date);
            setDateFocused(true);
        }
    }, [props.date]);

    const fetchSlotsForWorkshops = (date, serviceTypeId) => {
        const workshops = getWorkshopsForServiceType(serviceTypeId, isExternalProductApplied, isEvropaPromo, promoServiceIds);
        if (!workshops.length) return;

        setLoadingSlots(true);
        const zeroPad = (n, p) => String(n).padStart(p, '0');
        const dateFormatted = `${date.year()}-${zeroPad(date.month() + 1, 2)}-${zeroPad(date.date(), 2)}`;

        Promise.all(workshops.map(w =>
            fetch(`${process.env.REACT_APP_URL}/api/schedule?` + new URLSearchParams({
                id: serviceTypeId,
                depid: serviceTypeId,
                data: dateFormatted,
                serviceid: w.id
            }), {
                method: "GET",
                mode: 'cors',
                headers: {"Content-Type": "application/json"}
            })
                .then(r => r.json())
                .then(result => ({id: w.id, slots: result?.data || []}))
                .catch(() => ({id: w.id, slots: []}))
        )).then(results => {
            const byId = {};
            results.forEach(r => {
                byId[r.id] = r.slots;
            });
            setSlotsByWorkshop(byId);
            setLoadingSlots(false);
        });
    };

    const handleHotelChoice = (choice) => {
        props.setHotelPersonalChoice(choice);
        setSelectedSlot(null);
        if (choice === "1") {
            const minAllowed = moment().add(2, 'days').startOf('day');
            if (selectedDate.isBefore(minAllowed)) {
                setSelectedDate(minAllowed);
                setSlotsByWorkshop({});
            }
        }
    };

    const handleServiceTypeClick = (typeId) => {
        props.setServiceType(typeId);
        props.setService('');
        props.setDate(null);
        props.setHourSelected('');
        if (props.isHotel && props.setHotel) props.setHotel(false);
        if (props.setHotelPersonalChoice) props.setHotelPersonalChoice(null);
        props.handleNext();
    };

    const handleSlotClick = (workshopId, hour) => {
        setSelectedSlot({workshopId, hour});
    };

    const confirmSlot = () => {
        if (!selectedSlot) return;
        const zeroPad = (n, p) => String(n).padStart(p, '0');
        const d = selectedDate;
        const dateFormatted = `${d.year()}-${zeroPad(d.month() + 1, 2)}-${zeroPad(d.date(), 2)}`;
        props.setService(selectedSlot.workshopId);
        props.setDate(d);
        props.setFormattedDate(dateFormatted);
        props.setHourSelected(selectedSlot.hour);
        props.handleNext();
    };

    const fetchHoursForEdit = (date) => {
        const zeroPad = (n, p) => String(n).padStart(p, '0');
        const dateFormatted = `${date.year()}-${zeroPad(date.month() + 1, 2)}-${zeroPad(date.date(), 2)}`;
        props.setFormattedDate(dateFormatted);
        fetch(`${process.env.REACT_APP_URL}/api/schedule?` + new URLSearchParams({
            id: props.serviceType,
            depid: props.serviceType,
            data: dateFormatted,
            serviceid: props.service
        }), {
            method: "GET",
            mode: 'cors',
            headers: {"Content-Type": "application/json"}
        })
            .then(r => r.json())
            .then(result => {
                if (result?.data) {
                    if (props.editMode && props.hourSelectedInitial) {
                        result.data.push({fhour: props.hourSelectedInitial, limit: 1, used: '0', isonline: '0', tmp: '30-Jun-2022 2:38'});
                    }
                    if (props.editMode) {
                        result.data.sort((a, b) => parseFloat(a.fhour) - parseFloat(b.fhour));
                    }
                    setAvailableHours(result.data);
                }
            })
            .catch(() => {});
    };

    const padHour = (h) => h ? h.replace(/^(\d):/, '0$1:') : h;

    const numberWithCommas = (x) => Number(x).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");

    const visibleServiceTypes = SERVICE_TYPE_DATA.filter(type => {
        if (isExternalProductApplied) return type.id === 1;
        if (isEvropaPromo) return [4, 7].includes(type.id);
        if (promoServiceType) return type.id === promoServiceType;
        return true;
    });

    const editModeDepartments = props.service === 1 ? lulin : (props.service === 2 ? mladost : props.service === 6 ? hitMladost : evropa);

    const workshops = getWorkshopsForServiceType(props.serviceType, isExternalProductApplied, isEvropaPromo, promoServiceIds);

    return (
        <React.Fragment>
            {/* External product display */}
            {isExternalProductApplied && (
                <Grid container spacing={2} sx={{mb: 2}}>
                    <Grid item xs={isExternalImageProduct ? 9 : 12}>
                        <Typography>🛞 Запазихте: <QuantitySelect
                            externalProductQuantity={props.externalProductQuantity}
                            setExternalProductQuantity={props.setExternalProductQuantity}
                        /> бр. {props.externalProductName}{props.externalProductPrice ? ` - Цена - ${props.externalProductQuantity} X ${props.externalProductPrice} = ${numberWithCommas(Number(props.externalProductQuantity) * Number(props.externalProductPrice))} €` : ''}</Typography>
                    </Grid>
                    {isExternalImageProduct && (
                        <Grid item xs={3}>
                            <a href={props.externalProductImage} target={'_blank'}>
                                <img style={{width: '70%'}} src={props.externalProductImage} alt=""/>
                            </a>
                        </Grid>
                    )}
                </Grid>
            )}

            {/* ── Edit mode ── */}
            {props.editMode && (
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <FormControl fullWidth>
                            <InputLabel>Услуга</InputLabel>
                            <Select
                                value={props.serviceType}
                                label="Услуга"
                                disabled={isExternalProductApplied}
                                onChange={(event) => {
                                    props.setServiceType(event.target.value);
                                    if (props.date !== null && props.date !== "") props.setDate("");
                                    props.setHourSelected("");
                                    setDateFocused(true);
                                }}
                            >
                                {editModeDepartments.map(dept => (
                                    <MenuItem key={'service_' + dept.id} value={dept.id}>{dept.name}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                        <FormControl fullWidth>
                            <LocalizationProvider adapterLocale={'bg'} dateAdapter={AdapterMoment}>
                                <MobileDatePicker
                                    label="Дата"
                                    inputFormat="DD MMM yyyy"
                                    value={props.date}
                                    showToolbar={false}
                                    minDate={props.isHotel || props.hotelPersonalChoice === "1" || isExternalProductApplied ? moment().add(2, 'days') : (props.serviceType === 1 || isPastCutoff) ? moment().add(1, 'days') : moment()}
                                    maxDate={props.serviceType === 7 ? moment().add(3, 'months') : null}
                                    closeOnSelect={true}
                                    disabled={!props.serviceType}
                                    onChange={(v) => {
                                        setDateFocused(false);
                                        setHourFocused(true);
                                        props.setDate(v);
                                        props.setHourSelected('');
                                    }}
                                    renderInput={(params) => <TextField focused={isDateFocused} {...params}/>}
                                />
                            </LocalizationProvider>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                        <FormControl fullWidth focused={isHourFocused}>
                            <InputLabel>Час</InputLabel>
                            <Select
                                value={props.hourSelected}
                                label="Час"
                                disabled={!props.date}
                                onChange={(event) => {
                                    props.setHourSelected(event.target.value);
                                    props.handleNext();
                                }}
                            >
                                {availableHours && availableHours.map(hour => {
                                    if (Number(hour.used) < Number(hour.limit)) {
                                        return <MenuItem key={hour.fhour} value={hour.fhour}>{padHour(hour.fhour)}</MenuItem>;
                                    }
                                })}
                                {(!availableHours || availableHours.filter(h => Number(h.used) < Number(h.limit)).length === 0) ?
                                    <MenuItem disabled>Този ден няма свободен час!</MenuItem> : null}
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
            )}

            {/* Промо кодът се проверява — услугите се крият, за да не мигат преди предварителния избор */}
            {!props.editMode && props.activeStep === 0 && props.promoLoading && (
                <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1.5, py: 6}}>
                    <CircularProgress/>
                    <Typography variant="body2" color="text.secondary">Проверяваме промо кода…</Typography>
                </Box>
            )}

            {/* ── Step 0: Service type selection ── */}
            {!props.editMode && props.activeStep === 0 && !props.promoLoading && (
                <Grid container spacing={2}>
                   {/* <Grid item xs={12}>
                        <Typography variant="h6" gutterBottom>
                            Изберете услуга
                        </Typography>
                    </Grid>*/}
                    {visibleServiceTypes.map(type => (
                        <Grid item xs={12} sm={visibleServiceTypes.length === 1 ? 12 : 12} key={type.id}>
                            <Card
                                elevation={3}
                                sx={{
                                    cursor: 'pointer',
                                    transition: 'transform 0.15s ease, box-shadow 0.15s ease',
                                    '&:hover': {transform: 'translateY(-4px)', boxShadow: 8},
                                }}
                            >
                                <CardActionArea onClick={() => handleServiceTypeClick(type.id)}>
                                    <Box sx={{
                                        background: `linear-gradient(160deg, ${type.bgColor} 0%, ${type.bgColor}bb 100%)`,
                                        height: 140,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        overflow: 'hidden',
                                        position: 'relative',
                                    }}>
                                        {type.image ? (
                                            <img
                                                src={type.image}
                                                alt={type.name}
                                                style={{width: '100%', height: '100%', objectFit: 'cover', objectPosition: type.objectPosition || 'left center', position: 'absolute', inset: 0}}
                                                onError={e => { e.target.style.display = 'none'; }}
                                            />
                                        ) : (
                                            <Typography sx={{fontSize: 72, lineHeight: 1, userSelect: 'none'}}>
                                                {type.emoji}
                                            </Typography>
                                        )}
                                        {/* Name overlay — centered on top of image */}
                                        <Box sx={{position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(0,0,0,0.28)'}}>
                                            <Typography sx={{color: 'white', fontSize: '1.7rem', fontWeight: 800, letterSpacing: 0.5, textShadow: '0 2px 8px rgba(0,0,0,0.55)', userSelect: 'none'}}>
                                                {type.name}
                                            </Typography>
                                        </Box>
                                    </Box>
                                   {/* <CardContent sx={{textAlign: 'center', py: 1.5}}>
                                        <Typography variant="h6" fontWeight="bold" sx={{display: 'none'}}>{type.name}</Typography>
                                        <Typography variant="body2" color="text.secondary">{type.description}</Typography>
                                    </CardContent>*/}
                                </CardActionArea>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            )}

            {/* ── Step 1: Workshop cards with photo + date picker + slots ── */}
            {!props.editMode && props.activeStep === 1 && (
                <Grid container spacing={2} sx={{pb: selectedSlot ? 11 : 2}}>
                    {/* Hotel tires question — must be answered before continuing */}
                    {props.serviceType === 1 && !isExternalProductApplied && (
                        <Grid item xs={12}>
                            {props.hotelPersonalChoice == null ? (
                                <Alert severity="info" icon={false} sx={{alignItems: 'flex-start'}}>
                                    <Box>
                                        <Typography style={{fontSize: 18, textAlign: 'center'}}>Имате ли гуми на съхранение в 6+, които желаете да изтеглим от хотела?</Typography>
                                    </Box>
                                    <Box sx={{display: 'flex', gap: 2, mt: 2, justifyContent: 'center'}}>
                                        <Button color="inherit"  variant={'outlined'} onClick={() => handleHotelChoice("1")}>Да</Button>
                                        <Button color="inherit" variant={'outlined'} onClick={() => handleHotelChoice("0")}>Не</Button>
                                    </Box>
                                </Alert>
                            ) : (
                                <Alert
                                    severity={props.hotelPersonalChoice === "1" ? "warning" : "info"}
                                    action={<Button color="inherit" size="small" onClick={() => props.setHotelPersonalChoice(null)}>Промени</Button>}
                                >
                                    {props.hotelPersonalChoice === "1"
                                        ? "Хотел за гуми — минимална дата след 2 дни."
                                        : "Нямате гуми на съхранение."
                                    }
                                </Alert>
                            )}
                        </Grid>
                    )}

                    {/* Date picker — hidden until hotel question answered (for Гуми) */}
                    {(props.serviceType !== 1 || isExternalProductApplied || props.hotelPersonalChoice != null) && (
                        <Grid item xs={12}>
                            <Typography style={{textAlign: 'center'}} variant="body1" color="text.secondary">
                                Избрана услуга: <strong>{SERVICE_TYPE_DATA.find(t => t.id === props.serviceType)?.name}</strong>
                            </Typography>
                        </Grid>
                    )}
                    {(props.serviceType !== 1 || isExternalProductApplied || props.hotelPersonalChoice != null) && (
                        <Grid item xs={(props.serviceType === 1 && !isExternalProductApplied) ? 6 : 12}>
                            <LocalizationProvider adapterLocale={'bg'} dateAdapter={AdapterMoment}>
                                <MobileDatePicker
                                    label="Дата"
                                    inputFormat="DD MMM yyyy"
                                    value={selectedDate}
                                    showToolbar={false}
                                    minDate={props.isHotel || props.hotelPersonalChoice === "1" || isExternalProductApplied ? moment().add(2, 'days') : (props.serviceType === 1 || isPastCutoff) ? moment().add(1, 'days') : moment()}
                                    maxDate={props.serviceType === 7 ? moment().add(3, 'months') : null}
                                    closeOnSelect={true}
                                    open={datePickerOpen}
                                    onOpen={() => setDatePickerOpen(true)}
                                    onClose={() => setDatePickerOpen(false)}
                                    onChange={(newDate) => {
                                        setSelectedDate(newDate);
                                        setSlotsByWorkshop({});
                                        setSelectedSlot(null);
                                        setExpandedWorkshops({});
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            fullWidth
                                            size="small"
                                            {...params}
                                            onClick={() => setDatePickerOpen(true)}
                                            inputProps={{...params.inputProps, readOnly: true, style: {cursor: 'pointer'}}}
                                            InputProps={{
                                                ...params.InputProps,
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <CalendarMonthIcon color="primary"/>
                                                    </InputAdornment>
                                                ),
                                                sx: {
                                                    cursor: 'pointer',
                                                    '&:hover .MuiOutlinedInput-notchedOutline': {borderColor: 'primary.main'},
                                                    ...(showTapHint && {
                                                        animation: 'datePulse 1.8s ease-in-out infinite',
                                                        '@keyframes datePulse': {
                                                            '0%, 100%': {boxShadow: '0 0 0 0 rgba(25,118,210,0)'},
                                                            '50%': {boxShadow: '0 0 0 5px rgba(25,118,210,0.18)'},
                                                        },
                                                    }),
                                                },
                                            }}
                                        />
                                    )}
                                />
                            </LocalizationProvider>
                        </Grid>
                    )}

                    {/* Tires shop shortcut */}
                    {(props.serviceType !== 1 || isExternalProductApplied || props.hotelPersonalChoice != null) && props.serviceType === 1 && !isExternalProductApplied && (
                        <Grid item xs={6}>
                            <Button
                                variant="outlined"
                                size="small"
                                onClick={() => setTiresDialogOpen(true)}
                            >
                                Добави нови гуми
                            </Button>
                        </Grid>
                    )}

                    {/* Workshop cards — also gated behind hotel question */}
                    {(props.serviceType !== 1 || isExternalProductApplied || props.hotelPersonalChoice != null) && workshops.map(workshop => {
                        const available = (slotsByWorkshop[workshop.id] || [])
                            .filter(s => Number(s.used) < Number(s.limit));

                        return (
                            <Grid item xs={12} key={workshop.id}>
                                <Card elevation={3}>
                                    {/* Workshop photo — split: service image left, map right */}
                                    <Box sx={{height: 160, display: 'flex', overflow: 'hidden', position: 'relative'}}>

                                        {/* Left: workshop photo */}
                                        <Box sx={{flex: '1 1 62%', position: 'relative', overflow: 'hidden', backgroundColor: workshop.bgColor}}>
                                            {(() => {
                                                const effectiveImage = workshop[SERVICE_TYPE_IMAGE_KEY[props.serviceType]] || workshop.image;
                                                const effectiveImageStyle = workshop[SERVICE_TYPE_IMAGE_STYLE_KEY[props.serviceType]] || {};
                                                return effectiveImage ? (
                                                <img
                                                    src={effectiveImage}
                                                    alt={workshop.name}
                                                    style={{width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'left center', ...effectiveImageStyle}}
                                                />
                                            ) : (
                                                <Box sx={{width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', background: `linear-gradient(160deg, ${workshop.bgColor} 0%, ${workshop.bgColor}99 100%)`}}>
                                                    <Typography sx={{fontSize: 72, userSelect: 'none'}}>{workshop.emoji}</Typography>
                                                </Box>
                                            );
                                            })()}
                                            {/* НОВО ribbon — top-right corner of photo */}
                                            {workshop.is_new && (
                                                <Box sx={{
                                                    position: 'absolute',
                                                    top: 14,
                                                    right: -28,
                                                    width: 110,
                                                    transform: 'rotate(45deg)',
                                                    backgroundColor: '#e53935',
                                                    color: 'white',
                                                    fontSize: '0.7rem',
                                                    fontWeight: 800,
                                                    letterSpacing: 1.5,
                                                    textAlign: 'center',
                                                    py: 0.5,
                                                    boxShadow: '0 2px 6px rgba(0,0,0,0.35)',
                                                    userSelect: 'none',
                                                    zIndex: 2,
                                                }}>
                                                    НОВО
                                                </Box>
                                            )}
                                            {/* Gift photo — round, edges fading into the workshop photo, top-right corner */}
                                            {props.serviceType === 7 && workshop.gtpPromoLabel && workshop.gtpPromoImage && (
                                                <Box sx={{
                                                    position: 'absolute',
                                                    top: 2,
                                                    right: 2,
                                                    width: 70,
                                                    height: 70,
                                                    zIndex: 1,
                                                    pointerEvents: 'none',
                                                }}>
                                                    <img
                                                        src={workshop.gtpPromoImage}
                                                        alt="подарък"
                                                        style={{
                                                            width: '100%',
                                                            height: '100%',
                                                            objectFit: 'contain',
                                                            WebkitMaskImage: 'radial-gradient(circle, black 45%, rgba(0,0,0,0.5) 62%, transparent 74%)',
                                                            maskImage: 'radial-gradient(circle, black 45%, rgba(0,0,0,0.5) 62%, transparent 74%)',
                                                        }}
                                                    />
                                                </Box>
                                            )}
                                            {/* Name overlay */}
                                            <Box sx={{position: 'absolute', bottom: 0, left: 0, right: 0, background: 'linear-gradient(to top, rgba(0,0,0,0.78) 0%, transparent 100%)', p: 1.5}}>
                                                <Typography variant="h6" sx={{color: 'white', fontWeight: 'bold', lineHeight: 1.2}}>
                                                    {workshop.name}
                                                </Typography>
                                                {workshop.description && (
                                                    <Typography variant="caption" sx={{color: 'rgba(255,255,255,0.75)'}}>
                                                        {workshop.description}
                                                    </Typography>
                                                )}
                                            </Box>
                                        </Box>

                                        {/* Right: blurred map — links to Google Maps */}
                                        {workshop.mapImage && (
                                            <Box
                                                component="a"
                                                href={workshop.mapUrl}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                onClick={e => e.stopPropagation()}
                                                sx={{
                                                    flex: '0 0 26%',
                                                    position: 'relative',
                                                    overflow: 'hidden',
                                                    display: 'flex',
                                                    textDecoration: 'none',
                                                    cursor: 'pointer',
                                                    '&:hover .map-overlay': {backgroundColor: 'rgba(255,255,255,0.72)'},
                                                }}
                                            >
                                                <img
                                                    src={workshop.mapImage}
                                                    alt="карта"
                                                    style={{width: '100%', height: '100%', objectFit: 'cover', filter: 'blur(0.3px)', transform: 'scale(1.04)'}}
                                                />
                                                <Box className="map-overlay" sx={{position: 'absolute', inset: 0, backgroundColor: 'rgba(255,255,255,0.55)', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 0.5, transition: 'background-color 0.2s'}}>
                                                    <MapIcon sx={{color: 'rgba(0,0,0,0.65)', fontSize: 28}}/>
                                                    <Typography sx={{color: 'rgba(0,0,0,0.5)', fontSize: '0.65rem', fontWeight: 600, textAlign: 'center', lineHeight: 1.3, px: 0.5}}>
                                                        виж на<br/>картата
                                                    </Typography>
                                                </Box>
                                            </Box>
                                        )}

                                        {/* Red ribbon promo (see sample.png) — centered over the photo column (74% of card), clear of the map */}
                                        {props.serviceType === 7 && workshop.gtpPromoLabel && (
                                            <Box sx={{
                                                position: 'absolute',
                                                top: 10,
                                                left: '37%',
                                                transform: 'translateX(-50%)',
                                                width: 'max-content',
                                                maxWidth: 'calc(74% - 24px)',
                                                zIndex: 2,
                                                pointerEvents: 'none',
                                                userSelect: 'none',
                                                filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.35))',
                                            }}>
                                                {/* Ribbon tails — darker red, notched, peeking out below the band */}
                                                <Box sx={{
                                                    position: 'absolute',
                                                    top: 8,
                                                    left: -18,
                                                    width: 36,
                                                    height: '85%',
                                                    backgroundColor: '#b71c1c',
                                                    clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0 100%, 30% 50%)',
                                                }}/>
                                                <Box sx={{
                                                    position: 'absolute',
                                                    top: 8,
                                                    right: -18,
                                                    width: 36,
                                                    height: '85%',
                                                    backgroundColor: '#b71c1c',
                                                    clipPath: 'polygon(0 0, 100% 0, 70% 50%, 100% 100%, 0 100%)',
                                                }}/>
                                                {/* Main band */}
                                                <Box sx={{
                                                    position: 'relative',
                                                    background: 'linear-gradient(180deg, #ef5350 0%, #d32f2f 55%, #c62828 100%)',
                                                    color: 'white',
                                                    fontWeight: 800,
                                                    fontSize: {xs: '0.78rem', sm: '0.82rem'},
                                                    lineHeight: 1.3,
                                                    textAlign: 'center',
                                                    px: {xs: 1.5, sm: 2.5},
                                                    py: 0.75,
                                                    borderRadius: '10px',
                                                }}>
                                                    {workshop.gtpPromoLabel}
                                                </Box>
                                            </Box>
                                        )}
                                    </Box>

                                    <CardContent sx={{ pl: { xs: 0.5, sm: 2 } }}>
                                        <Divider sx={{mb: 1.5}}/>

                                        {/* Available time slots */}
                                        {loadingSlots ? (
                                            <Box sx={{display: 'flex', justifyContent: 'center', py: 2}}>
                                                <CircularProgress size={24}/>
                                            </Box>
                                        ) : available.length > 0 ? (() => {
                                            const useShowMore = props.serviceType === 1;
                                            const isExpanded = !useShowMore || !!expandedWorkshops[workshop.id];
                                            const visible = isExpanded ? available : available.slice(0, 20);
                                            return (
                                                <>
                                                    <Box sx={{display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: 0.75}}>
                                                        {visible.map(slot => {
                                                            const isSelected = selectedSlot?.workshopId === workshop.id && selectedSlot?.hour === slot.fhour;
                                                            return (
                                                                <Chip
                                                                    key={slot.fhour}
                                                                    label={padHour(slot.fhour)}
                                                                    clickable
                                                                    color="primary"
                                                                    variant={isSelected ? "filled" : "outlined"}
                                                                    onClick={() => handleSlotClick(workshop.id, slot.fhour)}
                                                                    sx={{
                                                                        height: 36,
                                                                        fontSize: '0.82rem',
                                                                        '&.MuiChip-clickable:not(.MuiChip-filled):hover': {
                                                                            backgroundColor: 'rgba(48,207,196,0.18) !important',
                                                                            transition: 'background-color 0.22s ease',
                                                                        },
                                                                        '&.MuiChip-filled.MuiChip-clickable:hover': {
                                                                            backgroundColor: '#30cfc4 !important',
                                                                            boxShadow: '0 3px 12px rgba(0,150,136,0.6) !important',
                                                                        },
                                                                        ...(isSelected && {
                                                                            color: 'white',
                                                                            fontWeight: 700,
                                                                            boxShadow: '0 2px 8px rgba(0,150,136,0.45)',
                                                                            transform: 'scale(1.08)',
                                                                        }),
                                                                        transition: 'transform 0.15s ease, box-shadow 0.15s ease',
                                                                    }}
                                                                />
                                                            );
                                                        })}
                                                    </Box>
                                                    {useShowMore && !isExpanded && available.length > 20 && (
                                                        <Button
                                                            variant={'outlined'}
                                                            className={!selectedSlot ? 'show-more-attention' : undefined}
                                                            sx={{mt: 1, textTransform: 'none', fontSize: '0.8rem'}}
                                                            onClick={() => setExpandedWorkshops(prev => ({...prev, [workshop.id]: true}))}
                                                        >
                                                            Покажи още часове ({available.length - 20} още)
                                                        </Button>
                                                    )}
                                                </>
                                            );
                                        })() : (
                                            <Typography variant="body2" color="text.secondary" sx={{textAlign: 'center', py: 1}}>
                                                Няма свободни часове за тази дата
                                            </Typography>
                                        )}
                                    </CardContent>
                                </Card>
                            </Grid>
                        );
                    })}
                </Grid>
            )}

            {/* ── Sticky confirm button — portal to body so transform ancestors don't trap it ── */}
            {!props.editMode && props.activeStep === 1 && selectedSlot && ReactDOM.createPortal(
                <Box
                    className="slot-confirm-enter"
                    sx={{
                        position: 'fixed',
                        bottom: 0,
                        left: 0,
                        right: 0,
                        zIndex: 1300,
                        px: 2,
                        pt: 4,
                        pb: 2.5,
                        background: 'linear-gradient(to top, rgba(255,255,255,1) 55%, rgba(255,255,255,0) 100%)',
                        display: 'flex',
                        justifyContent: 'center',
                        pointerEvents: 'none',
                    }}
                >
                    <Button
                        variant="contained"
                        size="large"
                        onClick={confirmSlot}
                        sx={{
                            pointerEvents: 'auto',
                            borderRadius: 3,
                            px: 5,
                            py: 1.5,
                            fontSize: '1.05rem',
                            fontWeight: 700,
                            letterSpacing: 0.3,
                            color: 'white',
                            boxShadow: '0 6px 24px rgba(0,150,136,0.45)',
                        }}
                    >
                        Напред &nbsp;·&nbsp; {padHour(selectedSlot.hour)}
                    </Button>
                </Box>,
                document.body
            )}

            {tiresDialogOpen && (
                <TiresDialog
                    open={tiresDialogOpen}
                    onClose={() => setTiresDialogOpen(false)}
                    setExternalProductName={props.setExternalProductName}
                    setExternalProductQuantity={props.setExternalProductQuantity}
                    setExternalProductPrice={props.setExternalProductPrice}
                    setExternalProductImage={props.setExternalProductImage}
                    setDate={props.setDate}
                />
            )}
        </React.Fragment>
    );
}
